import React, { useEffect, useState } from "react";
import { ExpertPriceList } from "../../components/List/ExpertPriceList";
import ExpertDataService from "../../services/Expert";
import { useNavigate } from "react-router-dom";
import { FormControl, FormLabel, Switch, useToast } from "@chakra-ui/react";

export const SheetExpertList = () => {
  const [list, setList] = useState<any>([]);
  const [filterList,setFilterList]=useState<any>([]);
  const token = localStorage.getItem("logged_in_user_token");
  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  const fetchData = async () => {
    setIsLoading(true);
    ExpertDataService.getExperts(token)
      .then((res: any) => {
        // console.log(res.data);
        setList(res.data);
        setFilterList(res.data)
        setIsLoading(false);
      })
      .catch((error: any) => {
        setIsLoading(false);
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const handleSwitchChange = (event:any) => {
    setIsSwitchOn(event.target.checked);
    if (event.target.checked) {
      setFilterList(list)
    } else {
     const filteredData = list.filter((el:any)=>el.data.is_hidden === false)
     setFilterList(filteredData);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="container expert-pricing-div">
      <FormControl display="flex" alignItems="center">
        <FormLabel htmlFor="email-alerts" mb="0">
          Show hidden experts
        </FormLabel>
        <Switch 
        id="email-alerts"
        isChecked={isSwitchOn}
        onChange={handleSwitchChange} 
        />
      </FormControl>
      <div className="row justify-content-start">
        {filterList && filterList.length > 0 ? (
          filterList.map((el: any) => (
            <div
              key={el._id}
              className="col-md-3 col-sm-6 mb-2"
              style={{ paddingLeft: "5px", paddingRight: "5px" }}
            >
              <ExpertPriceList key={el._id} data = {el} func={fetchData} />
            </div>
          ))
        ) : (
          <h1 className="no-data">No Data Found</h1>
        )}
      </div>
    </div>
  );
};
